import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueMask from 'v-mask'
import VuetifyMask from 'vuetify-mask'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'

const options = {
  confirmButtonColor: '#4CAF50',
  cancelButtonColor: '#FF5252'
}

Vue.config.productionTip = false
Vue.use(VueSweetalert2, options)
Vue.use(VuetifyMask)
Vue.use(VueMask)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
